interface ScoreboardCoverageCellProps {
  inWindow: number
  extracted: number
}

export default function ScoreboardCoverageCell({ inWindow, extracted }: ScoreboardCoverageCellProps) {
  const title =
    extracted > 0
      ? `${inWindow} of ${extracted} extracted predictions have passed their resolve window`
      : `${inWindow} predictions have passed their resolve window`

  const share = extracted === 0 ? null : Math.min(100, Math.round((inWindow / extracted) * 100))

  return (
    <div className="text-center" title={title}>
      <div className="text-gray-700 dark:text-gray-300">{inWindow}</div>
      {extracted > 0 && (
        <div className="text-xs text-gray-500 dark:text-gray-400">
          {share}% of {extracted}
        </div>
      )}
    </div>
  )
}
